import React, { useState } from "react";
import {
    Container,
    Typography,
    TextField,
    Button,
    Box,
    Alert,
    Paper,
    MenuItem,
    FormControl,
    InputLabel,
    Select, FormControlLabel, Checkbox,
} from "@mui/material";
import {sendReportsData} from "../../api/axios";

const ReportForm = () => {
    const [email, setEmail] = useState("");
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const [reportType, setReportType] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [shouldPrint, setShouldPrint] = useState(false);


    const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);

    const handleSubmit = async () => {
        setError("");
        setSuccess("");

        if (!email || !dateFrom || !dateTo || !reportType) {
            setError("Sva polja su obavezna.");
            return;
        }

        if (!validateEmail(email)) {
            setError("Unesite ispravnu email adresu.");
            return;
        }

        try {
            await sendReportsData({
                email,
                dateFrom,
                dateTo,
                reportType,
                print: shouldPrint,
            });

            setSuccess("Izveštaj je uspešno poslat na email.");
        } catch (err) {
            console.error("Greška pri slanju izveštaja:", err);
        }
    };

    const reportTypes = [
        "Presek stanja",
        "Promet po poreskim stopama",
        "Promet po radnicima",
        "Promet po vrstama plaćanja",
        "Promet po artiklima",
        "Promet po kategorijama i artiklima",
        "Transakcije",
        "Lager lista",
        "Avansni računi",
    ];

    return (
        <Container maxWidth="sm">
            <Paper
                elevation={3}
                sx={{
                    mt: 5,
                    p: 4,
                    borderRadius: 3,
                    backgroundColor: "#ffffff",
                }}
            >
                <Typography
                    variant="h5"
                    align="center"
                    gutterBottom
                    sx={{ color: "#1976d2", mb: 3 }}
                >
                    Odaberite izveštaj i datum
                </Typography>

                <Box display="flex" flexDirection="column" gap={3}>
                    <FormControl fullWidth>
                        <InputLabel id="report-select-label">Tip izveštaja</InputLabel>
                        <Select
                            labelId="report-select-label"
                            value={reportType}
                            label="Tip izveštaja"
                            onChange={(e) => setReportType(e.target.value)}
                        >
                            {reportTypes.map((type, index) => (
                                <MenuItem key={index} value={type}>
                                    {type}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <TextField
                        label="Pošalji na email:"
                        type="email"
                        fullWidth
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />

                    <TextField
                        type="date"
                        fullWidth
                        value={dateFrom}
                        onChange={(e) => setDateFrom(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        label="Od datuma"
                    />

                    <TextField
                        type="date"
                        fullWidth
                        value={dateTo}
                        onChange={(e) => setDateTo(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        label="Do datuma"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={shouldPrint}
                                onChange={(e) => setShouldPrint(e.target.checked)}
                                color="primary"
                            />
                        }
                        label="Štampaj izveštaj"
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        disabled={!email || !dateFrom || !dateTo || !reportType}
                    >
                        Generiši izveštaj
                    </Button>

                    {error && <Alert severity="error">{error}</Alert>}
                    {success && <Alert severity="success">{success}</Alert>}
                </Box>
            </Paper>
        </Container>
    );
};

export default ReportForm;
